module.exports = __webpack_public_path__ + "05960fa6d947ca45c015988ec73693a3.jpg";